import { Col } from "antd";
import React from "react";
import LazyLoad from "react-lazyload";

import Heading from "../ProductHeading";
import styles from "./style.module.scss";

const UpcomingEvent = ({ product }) => {
  let eventsChart = product.acf.product_analysis_upcoming_events_chart
    .replace(/(\r\n|\n|\r)/gm, "")
    .replace(",}", "}");
  eventsChart = JSON.parse(eventsChart);
  eventsChart = { ...eventsChart, width: 930, height: 355 };
  
  return (
    <Col span={24} className={styles.upcomingEventCol}>
      <Heading text={`Sự kiện ảnh hưởng ${product.title}`} />
      <div className={styles["event"]}>
        <LazyLoad>
          <iframe 
            // scrolling="no" 
            allowtransparency="true" 
            frameBorder="0" 
            src={`https://www.tradingview-widget.com/embed-widget/events/?locale=vi_VN#${encodeURI(JSON.stringify(eventsChart))}`}
            style={{height: '400px', width: '100%'}}
          ></iframe>

          <div className="tradingview-widget-copyright">
            <a 
              href="https://www.tradingview.com/markets/currencies/economic-calendar/" 
              rel="noopener noreferrer" target="_blank"
            >
              <span className="blue-text">Economic Calendar</span>
            </a> by TradingView
          </div>
        </LazyLoad>
      </div>
    </Col>
  );
};
export default UpcomingEvent;
